import { LinkedService } from 'shell-models-lib';

export class MapperStagingSettings {
    constructor(
        public readonly stagingLinkedService?: LinkedService,
        public readonly stagingFolderPath?: string){
    }
}
